import { render, staticRenderFns } from "./ReleaseNotesListGrid.vue?vue&type=template&id=c4e78b18"
import script from "./ReleaseNotesListGrid.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesListGrid.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesListGrid.vue?vue&type=style&index=0&id=c4e78b18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports